import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildTrainingMembershipsDataTableFilter,
  useTrainingMembershipsDataTable,
} from 'generated/resources/datatable.graphql'
import { ExportTrainingsTeamFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const teamsFilter = (
  source: ReturnType<typeof useTrainingMembershipsDataTable>,
  teams: ExportTrainingsTeamFragment[]
) => {
  const options = teams.map((team) => ({
    label: team.name,
    value: team.id,
    component: (
      <Box>
        <Text size="300">{team.name}</Text>
      </Box>
    ),
  }))

  return buildTrainingMembershipsDataTableFilter(source, {
    identifier: 'teams_filter',
    title: i18n.t('trainings.trainings_revamp.training_employee_table.filters.team_id'),
    path: 'teamId',
    default: true,
    type: FilterType.Integer,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
  })
}
